import React from 'react';
import GeoAutocomplete from "./GeoAutocomplete";


export default function FormikGeoAutocomplete(props){

    const {field, form,onChange, ...otherProps} = props;

    function deleteDuplicates(values){
        return Object.values(values.reduce(
            (accumulator, item) => {

                accumulator[item.id] = item;

                return accumulator;
            },{}
        ));
    }

    return (
        <GeoAutocomplete

            isMulti={true}
            {...otherProps}
            onChange={(value)=>{

                const isMulti = props.isMulti;

                value = value || (isMulti ? [] : undefined)

                if(!!isMulti){

                    const withoutDuplicate = deleteDuplicates(value)

                    form.setFieldValue(field.name, withoutDuplicate)

                }

                else{

                    form.setFieldValue(field.name, value)

                }

                if(onChange)
                    onChange(value)

            }}
            value={field.value}
        />
    );
}